import { Controller } from "stimulus"

const MESSAGE_DURATION = 4000;

export default class extends Controller {
  static targets = [ "spinner", "success", "successText", "error", "errorText" ]

  originalButtonInnerHTML = null;
  messageTimeout = null;

  // Envía el formulario por fetch para poder mostrar el resultado en la misma
  // página en lugar de recargarla.
  async submit(event) {
    event.preventDefault();

    this.hideMessages();
    this.show();

    try {
      const response = await fetch(this.element.action, {
        method: (this.element.method || "post").toUpperCase(),
        body: new FormData(this.element),
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        credentials: "same-origin"
      });

      // Una respuesta HTML (p.ej. un redirect al login) no cuenta como éxito.
      const isJson = (response.headers.get("content-type") || "").includes("application/json");
      const data = isJson ? await response.json().catch(() => ({})) : {};

      if (!response.ok || !isJson) {
        throw new Error(data.message || `Error del servidor (HTTP ${response.status})`);
      }

      this.element.reset();
      this.showMessage(
        this.hasSuccessTarget ? this.successTarget : null,
        this.hasSuccessTextTarget ? this.successTextTarget : null,
        data.message
      );
    } catch (error) {
      this.showMessage(
        this.hasErrorTarget ? this.errorTarget : null,
        this.hasErrorTextTarget ? this.errorTextTarget : null,
        error.message
      );
    } finally {
      this.hide();
    }
  }

  show() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }

    // Busca el botón de submit dentro del elemento del controlador (el formulario)
    const submitButton = this.element.querySelector("button[type='submit']");
    if (submitButton) {
      // Almacena el contenido HTML original del botón si aún no se ha hecho
      if (this.originalButtonInnerHTML === null) {
        this.originalButtonInnerHTML = submitButton.innerHTML;
      }
      submitButton.disabled = true; // Deshabilita el botón

      const svgIcon = submitButton.querySelector("svg") ? submitButton.querySelector("svg").outerHTML : "";
      submitButton.innerHTML = `${svgIcon} Enviando...`;
    }
  }

  hide() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }

    const submitButton = this.element.querySelector("button[type='submit']");
    if (submitButton) {
      submitButton.disabled = false;


      if (this.originalButtonInnerHTML !== null) {
        submitButton.innerHTML = this.originalButtonInnerHTML;
      }

    }
  }

  hideMessages() {
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
      this.messageTimeout = null;
    }

    if (this.hasSuccessTarget) this.successTarget.classList.add("hidden");
    if (this.hasErrorTarget) this.errorTarget.classList.add("hidden");
  }

  showMessage(container, textElement, message) {
    if (!container) return;

    if (textElement && message) {
      textElement.textContent = message;
    }
    container.classList.remove("hidden");

    this.messageTimeout = setTimeout(() => {
      container.classList.add("hidden");
      this.messageTimeout = null;
    }, MESSAGE_DURATION);
  }
}